import React from 'react';

import { RescheduleNotice as RescheduleNoticeKind } from '@src/domains/sale-items';
import type { RescheduleNoticeView } from '@src/features/sales/reschedule/hooks/useRescheduleNotice';

import { RescheduleAvailabilityBox } from './RescheduleAvailabilityBox';
import { RescheduleExpiredAlert } from './RescheduleExpiredAlert';
import { RescheduleUnavailableAlert } from './RescheduleUnavailableAlert';

export type RescheduleNoticeProps = {
  notice: RescheduleNoticeView;
};

export const RescheduleNotice = (props: RescheduleNoticeProps) => {
  const { notice } = props;

  switch (notice.kind) {
    case RescheduleNoticeKind.Available:
      return <RescheduleAvailabilityBox remainingCount={notice.remainingCount} deadlineLabel={notice.deadlineLabel} />;
    case RescheduleNoticeKind.DeadlineExpired:
      return <RescheduleExpiredAlert />;
    case RescheduleNoticeKind.NotReschedulable:
      return <RescheduleUnavailableAlert />;
    default:
      return null;
  }
};

export default RescheduleNotice;
